import { ApolloLink } from '@apollo/client';

var passthroughLink = new ApolloLink(function (operation, forward) { return forward(operation); });
function passthrough() {
    return passthroughLink;
}

export default passthrough;
//# sourceMappingURL=passthrough.js.map
